export default __webpack_public_path__ + "static/media/perennial.43238122.png";